import { render, staticRenderFns } from "./CertificationPageDetails.vue?vue&type=template&id=652aea60&"
import script from "./CertificationPageDetails.vue?vue&type=script&lang=ts&"
export * from "./CertificationPageDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('652aea60')) {
      api.createRecord('652aea60', component.options)
    } else {
      api.reload('652aea60', component.options)
    }
    module.hot.accept("./CertificationPageDetails.vue?vue&type=template&id=652aea60&", function () {
      api.rerender('652aea60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Resource/Certifications/CertificationPageDetails.vue"
export default component.exports